import { path } from "../../config";
import { store } from "../../redux/store";
import fetchServer from "../fetchServer";

export async function bookFlight(data,userId,userType) {
  var result = {return: 0,msg: 'Error',data: {}}

  let token = store.getState().user.userData.accessToken;

  // console.log("userId - ",userId)
  console.log("[req] bookedFlight data - ",data,userId)

  await fetchServer({method: "POST",url: path.api+'/flights/order/',data,
    headers: {
      Authorization: `Bearer ${token}`,
      'user-id': userId,
      'user-type': userType?.toUpperCase() || undefined
    }
  })
  .then((res) => {
    console.log(" => ",res)
    if(res) {
      if(res?.data?.success) {
        result = {return: 1,msg: "Successfull",data: res.data.data};
      } else if(res?.error) result['msg'] = res?.error?.message;
    } 
  })
  .catch((err) => {
    console.log("Network Error: ",err);
  })

  return result;

}